import React from "react";

import { isPlace, Place } from "../../../../application/domain/proc-management";
import Title from "../../../atoms/proc-management/title";
import { RBACHidden } from "../../../helpers/rbac/rbac";
import { PlaceForm } from "./place-form";
import { SecondaryButton } from "@graffer-inc/console-design-kit";
import { useAuthContextV2 } from "../../../../auth-state";

type Props = {
  place: Place | Omit<Place, "id">;
  onPressSave: () => void;
  onChange: (path: (string | number)[], value: any) => void;
  isUpdating: boolean;
};

export const Content: React.FC<Props> = ({
  place,
  onPressSave,
  onChange,
  isUpdating,
}) => {
  const title = isPlace(place)
    ? `場所編集: ${place.name}`
    : "場所データ新規作成";
  const { auth } = useAuthContextV2();
  const disabledForm = !auth.hasPermissions(
    isPlace(place)
      ? "proc_management.places.update"
      : "proc_management.places.create",
  );

  return (
    <>
      <Title text={title} />
      <RBACHidden
        requirePermissions={
          isPlace(place)
            ? "proc_management.places.update"
            : "proc_management.places.create"
        }
      >
        <hr className="my-3" />
        <div className="columns">
          <div className="column has-text-right buttons">
            <div style={{ marginTop: "auto", marginBottom: "auto" }}>
              <SecondaryButton
                text={"現在の内容を保存する"}
                onClick={onPressSave}
                disabled={isUpdating}
              />
            </div>
          </div>
        </div>
      </RBACHidden>
      <hr className="my-3" />
      <PlaceForm place={place} onChange={onChange} disabled={disabledForm} />
    </>
  );
};

export default Content;
